export const todayWeekday = 4;

export const weeklyCalendar = [
  {
    weekday: 1,
    label: '周一',
    date: '2026-09-07',
    items: [
      { dramaId: 'chongsheng-haomen', dramaTitle: '重生之我在豪门当团宠', range: '第53-54集', time: '12:00' },
      { dramaId: 'jinxiu-yifei', dramaTitle: '锦绣医妃', range: '第46-47集', time: '19:30' },
    ],
  },
  {
    weekday: 2,
    label: '周二',
    date: '2026-09-08',
    items: [
      { dramaId: 'xindong-xinhao', dramaTitle: '心动信号：暗恋成真', range: '第31-32集', time: '20:00' },
    ],
  },
  {
    weekday: 3,
    label: '周三',
    date: '2026-09-09',
    items: [
      { dramaId: 'jinxiu-yifei', dramaTitle: '锦绣医妃', range: '第48-49集', time: '19:30' },
      { dramaId: 'wugang-mian', dramaTitle: '雾港迷案', range: '第25-27集', time: '21:00' },
    ],
  },
  {
    weekday: 4,
    label: '周四',
    date: '2026-09-10',
    items: [
      { dramaId: 'xindong-xinhao', dramaTitle: '心动信号：暗恋成真', range: '第33-34集', time: '20:00' },
    ],
  },
  {
    weekday: 5,
    label: '周五',
    date: '2026-09-11',
    items: [
      { dramaId: 'chongsheng-haomen', dramaTitle: '重生之我在豪门当团宠', range: '第55-56集', time: '12:00' },
      { dramaId: 'jinxiu-yifei', dramaTitle: '锦绣医妃', range: '第50-51集', time: '19:30' },
      { dramaId: 'shenzhai-bumianye', dramaTitle: '深宅不眠夜', range: '第19-20集', time: '22:00' },
    ],
  },
  {
    weekday: 6,
    label: '周六',
    date: '2026-09-12',
    items: [
      { dramaId: 'xindong-xinhao', dramaTitle: '心动信号：暗恋成真', range: '第35-36集', time: '20:00' },
      { dramaId: 'shenzhai-bumianye', dramaTitle: '深宅不眠夜', range: '第21-22集', time: '22:00' },
    ],
  },
  {
    weekday: 7,
    label: '周日',
    date: '2026-09-13',
    items: [
      { dramaId: 'wugang-mian', dramaTitle: '雾港迷案', range: '第28-30集', time: '21:00' },
    ],
  },
];